// @flow

import React, { type Node, useState } from 'react';

import { useSendVoucherGenerateEvent } from '@tectonics/analytics';
import { useEventBusListener } from '@tectonics/public-event-bus';
import { Separator } from '../../../../../atoms';
import styled  from 'styled-components';
import { NequiInstructions } from './nequi-instructions';
import { PaymentInstructions } from './payment-instructions';
import { HelpCenterInfo } from './help-center-info';

import {
  VoucherMailWarning,
  VoucherTicketAmount,
  VoucherTicketDueDateTime,
} from '../../commons/voucher';

export function NequiPageContent(): Node {
  const [isReady, setReady] = useState<bool>(false);

  useEventBusListener('bromelia:step:thank_you', () => {
    setReady(true);
  });

  useSendVoucherGenerateEvent(isReady);

  return (
    <div data-test-id="page-pending-payment">

      <p style={nequiTitleStyle}>
        Pago NEQUI generado!
      </p>

      <VoucherMailWarning />

      <Separator direction="vertical" size={5}/>

      <PaymentInfoWrapper>
        <VoucherTicketAmount />
        <VoucherTicketDueDateTime />
      </PaymentInfoWrapper>

      <Separator pattern="dotted" direction="vertical" size={5.5} />

      <NequiInstructions />

      <Separator pattern="dotted" direction="vertical" size={5.5} />

      <PaymentInstructions />

      <HelpCenterInfo />

    </div>
  );
}

const nequiTitleStyle = {
  fontSize: '22px',
  marginBottom: '16px',
  color: '#2397d4',
};

const PaymentInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 15px;
  border-radius: 5px;
  background: rgb(248, 248, 249);
`;
